import React from 'react';
import { BooleanInput, SelectInput } from 'react-admin';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../redux/integration/functions';
import CustomSearchInput from '../../commons/customSearchInput';

function SelectModule({ source }: any) {
  const { modules } = useSelector((state: any) => state.functions);
  const dispatch = useDispatch();
  const getData = (data: any) => {
    if (data === '') {
      dispatch(actions.getInitData('\'\''));
    } else {
      dispatch(actions.getInitData(data));
    }
  };
  return (
    <SelectInput
      source={source}
      choices={modules ?? []}
      onChange={(choice) => getData(choice.target.value)}
      variant="outlined"
    />
  );
}

function SelectScreen({ source }: any) {
  const { screens } = useSelector((state: any) => state.functions);
  return (
    <SelectInput
      source={source}
      choices={screens ?? []}
      variant="outlined"
    />
  );
}

function SelectFunction({ source }: any) {
  const { functions } = useSelector((state: any) => state.functions);
  return (
    <SelectInput
      source={source}
      choices={functions ?? []}
      variant="outlined"
    />
  );
}

export default [
  <CustomSearchInput source="Query" alwaysOn placeholder="keyword" />,
  <SelectModule
    source="moduleId"
  />,
  <SelectScreen
    source="screenId"
  />,
  <SelectFunction
    source="relatedFunctionId"
  />,
  <BooleanInput
    source="isActive"
    className="active-module"
  />,
];
